import classnames from 'classnames'

import styles from './toggle.module.scss'

export interface ToggleProps {
  active: boolean
  onToggle: () => void
  className?: string
}

const Toggle = ({ active = false, ...props }: ToggleProps) => {
  return (
    <div className={props.className}>
      <div
        className={classnames(styles.toggle, active && styles.active)}
        onClick={props.onToggle}
        data-testid="toggle-icon"
      >
        <div className={styles.indicator}></div>
      </div>
    </div>
  )
}

export default Toggle
